
import { Drawer, SimpleToolbar, Loader, Toast } from "../../../../components";
import { Grid, Container, makeStyles } from "@material-ui/core";
import { useDrawer } from "../../../../hooks";
import { AuthContext } from "../../../../context";
import { useContext, useEffect, useState } from "react";

import { laboratoryServices } from "../../../../services";
import SelectRepresentative from "./selectProducts";
import AssignToRepresentative from "./assignToRepresentative";
import StepperMobile from "./StepperMobile";
import useSelectedProducts from "../../../../hooks/useSelectedProducts";

const steps = [
  {
    label: "Representative",
    content: SelectRepresentative,
  },
  {
    label: "Assign",
    content: AssignToRepresentative,
  },
];
export default function AssignToRepresentativesScreen() {
  const classes = useStyles();
  const { authState } = useContext(AuthContext);
  const { isOpen, setIsOpen } = useDrawer();
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [labRepresentative, setLabRepresentative] = useState([]);

  const {
    selected: assignments,
    addProduct,
    addUser,
    removeProduct,
    removeUser,
    updateProductQty,
  } = useSelectedProducts();
  const StepComponent = steps[activeStep].content;

  const handleAssignToRepresentative = async ({ labRepreId }) => {
    const productsPerRepresentative = Object.entries(assignments[labRepreId]);
    const invalidData = productsPerRepresentative.some(
      ([_, quantity]) => quantity <= 0
    );
    if (invalidData) {
      setToast(true);
      setToastMessage("No puede asignar una cantidad inferior a uno (1) ");
      return;
    }
    const assignmentsToRepresentativesStocks = productsPerRepresentative.reduce(
      (acc, cur) => {
        acc.push({ labRepreId, productId: cur[0], quantity: cur[1] });
        return acc;
      },
      []
    );
    try {
      const { status, response } =
        await laboratoryServices.assignToRepresentativesStocks({
          token: authState.token,
          laboratoryId: authState.user.laboratory._id,
          assignmentsToRepresentativesStocks,
        });
      setToast(true);
      if (status === 200) {
        setToastMessage("Productos asignados exitosamente");
      } else {
        setToastMessage(response.message);
      }
    } catch (error) {}

    // await fakeNetwork();
  };
  const nextStep = () => {
    if (Object.keys(assignments).length === 0) {
      setToast(true);
      setToastMessage("Debe seleccionar al menos un representante");
      return;
    }
    setActiveStep((prev) => prev + 1);
  };
  const prevStep = () => {
    setActiveStep((prev) => prev - 1);
  };

  // useEffect(() => {
  //   console.log(assignments);
  // }, [assignments]);

  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        {/* {loading && <Loader loading={true} />} */}
        <Toast
          open={toast}
          message={toastMessage}
          close={() => setToast(false)}
        />
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              hideExport={authState.user.laboratory}
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              noSearchBar
            />
          </Container>
          <Container maxWidth={"md"} component={"main"}>
            <Container maxWidth={"sm"} style={{ marginTop: 20, padding: 0 }}>
              <StepperMobile
                activeStep={activeStep}
                prev={prevStep}
                next={nextStep}
              />
            </Container>
            {steps[activeStep].label === "Representative" ? (
              <StepComponent
                assignments={assignments}
                addUser={addUser}
                removeUser={removeUser}
                labRepresentative={labRepresentative}
                setLabRepresentative={setLabRepresentative}
              />
            ) : (
              <StepComponent
                assignments={assignments}
                addProduct={addProduct}
                removeProduct={removeProduct}
                updateProductQty={updateProductQty}
                labRepresentative={labRepresentative}
                onSubmit={handleAssignToRepresentative}
              />
            )}
          </Container>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    flex: 1,
    minHeight: "100vh",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    "& main": {
      flexGrow: 1,
    },
  },
  stepper_buttons: {
    display: "flex",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
    justifyContent: "center",
    [theme.breakpoints.up("sm")]: {
      justifyContent: "end",
    },
  },
}));

const fakeNetwork = (t = 2000) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve("hi");
    }, t);
  });
